<template>
  <div class="smy__card-full-box">
    <div class="search">
      <!-- 详细筛选条件 -->
      <div>
        <div class="search-detail">
          <div class="search-detail-item">
            <Input
              class="search-input"
              placeholder="请输入姓名"
              v-model="searchForm.name"
            ></Input>
          </div>
          <div class="search-detail-item">
            <Input
              class="search-input"
              placeholder="请输入手机号"
              v-model="searchForm.mobile"
            ></Input>
          </div>
          <div class="search-detail-item">
            <!-- <Input
              class="search-input"
              placeholder="请输入角色"
              v-model="searchForm.role_name"
            ></Input> -->
            <Select
              clearable
              class="search-input"
              placeholder="请选择角色分配情况"
              element-id="industryType"
              v-model="searchForm.roleState"
            >
              <Option
                v-for="spareType in roleTypeList"
                :key="spareType.value"
                :value="spareType.value"
              >
                {{ spareType.name }}
              </Option>
            </Select>
          </div>
          <div class="search-detail-item">
            <Button
              type="primary"
              class="search-button"
              @click=";(pageIndex = 0), loadList()"
            >
              查找
            </Button>
            <Button class="search-button" @click="resetSearchForm">重置</Button>
          </div>
        </div>
      </div>
    </div>
    <!-- 工单列表 -->
    <div class="table table-sticky">
      <Table
        stripe
        ref="table"
        :loading="listLoading"
        :columns="columns"
        :data="list"
      ></Table>
    </div>
    <!-- 分页控件 -->
    <Page
      show-total
      show-sizer
      class="page"
      placement="top"
      :current="pageIndex + 1"
      :total="count"
      :page-size-opts="pageSizeOpts"
      @on-change="pageIndexChange"
      @on-page-size-change="pageSizeChange"
    ></Page>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'FollowDetailRightFour',
  props: {
    id: {
      type: [Number, String],
    },
  },
  data() {
    return {
      pageSize: 10,
      pageIndex: 0,
      listLoading: false, // 表格加载状态
      count: 0,
      list: [],
      searchForm: {
        name: '',
        mobile: '',
        roleState: '',
      },
      roleTypeList: [
        {
          value: '1',
          name: '只显示已分配角色人员',
        },
        {
          value: '2',
          name: '只显示未分配角色人员',
        },
      ],
    }
  },
  computed: {
    ...mapState('table', ['columnsCheckedAll', 'pageSizeOpts']),
    ...mapState('user', ['user']),

    columns() {
      const allColumns = [
        {
          title: '姓名',
          key: 'name',
          width: 120,
          render: (h, { row }) => {
            const sysrole = +this.user.sysrole
            const isMain = +this.user.isMain
            const host = 'https://dingtalk.zhongyifu.cn/index'
            const url = `${host}?epid=${this.id}&userid=${row.id}`

            return h(
              'div',
              {
                class: sysrole === 1 && isMain === 1 ? 'main-color' : '',
                on: {
                  click: () => {
                    if (sysrole === 1 && isMain === 1) {
                      window.open(url, '_blank')
                    }
                  },
                },
                style: {
                  cursor: sysrole === 1 && isMain === 1 ? 'pointer' : '',
                },
              },
              row.name
            )
          },
        },
        {
          title: '手机号',
          key: 'mobile',
          width: 140,
        },
        {
          title: '分配角色',
          key: 'role_name',
          minWidth: 260,
        },
        {
          key: ' ',
          title: ' ',
        },
      ]
      return allColumns
    },
  },
  methods: {
    // 重置搜索框
    resetSearchForm() {
      this.searchForm = {
        name: '',
        mobile: '',
        roleState: '',
      }
      this.pageIndex = 0
      this.loadList()
    },
    // 加载列表数据
    loadList() {
      this.listLoading = true
      this.$http
        .all([
          this.$http.get('enterprise/mgr/user/list', {
            params: {
              pageIndex: this.pageIndex,
              pageSize: this.pageSize,
              ...this.searchForm,
              id: this.id, // 企业id
            },
          }),

          this.$http.get('enterprise/mgr/user/count', {
            params: {
              ...this.searchForm,
              id: this.id,
            },
          }),
        ])
        .then(
          this.$http.spread((res1, res2) => {
            if (res1.success && res2.success) {
              this.list = res1.data
              this.count = res2.data
              this.listLoading = false
            }
          })
        )
    },
    // 分页 每页大小 改变回调
    pageSizeChange(pageSize) {
      this.pageSize = pageSize
      this.loadList()
    },
    // 分页 页码 改变回调
    pageIndexChange(pageIndex) {
      this.pageIndex = pageIndex - 1
      this.loadList()
    },
  },
  created() {
    this.loadList()
  },
}
</script>

<style lang="less" scoped>
.search {
  margin-bottom: 16px;
  .search-top {
    display: flex;
    justify-content: space-between;

    .search-top-left {
      display: flex;
      width: 70%;

      .search-input {
        width: 80%;

        // margin-left: 10px;
      }

      .search-button {
        margin-left: 10px;
      }
    }

    .search-top-right {
      .filter-column {
        display: flex;
        flex-direction: column;
        overflow: hidden;
      }

      .search-button {
        margin-left: 6px;
      }
    }
  }

  .search-detail {
    display: flex;
    flex-wrap: wrap;
    margin-top: 20px;
    // height: 120px;

    .search-detail-item {
      width: 24.25%;

      .search-input {
        width: 100%;
        margin-bottom: 10px;
      }

      .search-button {
        margin-right: 6px;
        // margin-bottom: 10px;
      }
    }

    .search-detail-item:nth-child(2n + 1),
    .search-detail-item:nth-child(4n + 2) {
      margin-right: 1%;
    }
  }

  .search-detail-close {
    height: 0;
    opacity: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/customManage/followCustomList/cusFollowDetail/FollowDetailRightFour.vue